import jwtDecode from 'jwt-decode';

import {
  VERIFY,
} from '@/store/constants';

export default {
  checkAuth(ctx) {
    const jwt = localStorage.getItem('access_token');
    if (jwt && jwtDecode(jwt).exp * 1000 > Date.now()) {
      // Redirect to homepage if not logged in
      if (ctx.$route.name === 'Login') {
        ctx.$router.push('/');
      }
      if (!ctx.$store.state.currentUser) {
        // ctx.$store.commit('appLoading', true);
        ctx.$store.dispatch(VERIFY);
      }
      return true;
    }
    if (ctx.$route.name === null) {
      return false;
    }
    if (
      ctx.$route.name !== 'Login'
      && ctx.$route.name !== 'Request Access'
      && ctx.$route.name !== 'Forgot Password'
      && ctx.$route.name !== 'Set Password'
    ) {
      ctx.$router.push('/login');
      return true;
    }
    return true;
  },

  getAuthHeader() {
    return {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    };
  },
};



// WEBPACK FOOTER //
// ./src/utils/auth.js